<script lang="ts">
  let { text = undefined, offsetX = undefined }: { text?: string; offsetX?: string } = $props();
</script>

<oc-skip-link-v1 style:--oc-skip-link-v1-offset-x={offsetX}>
  <oc-button-v1 variant="secondary" size={/*      */ "50"} icon-type-left="skip-link">
    {text ? `${text} überspringen` : "Überspringen"}
  </oc-button-v1>
</oc-skip-link-v1>

<style>
  oc-skip-link-v1:not(:defined) {
    display: none;
  }
</style>
